<svelte:head>
    <title>The Phoenix Pages - Auth</title>
</svelte:head>

<script>
	import { onMount } from 'svelte';

    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());

    onMount(async () => {
        // Get access and refresh tokens

        var urlencoded = new URLSearchParams();
        urlencoded.append('client_id', '834733070522777680');
        urlencoded.append('client_secret', '5rEP-nGcEmbcvUqVuHe6mjTISod18suY');
        urlencoded.append('grant_type', 'authorization_code');
        urlencoded.append('code', params.code);
        urlencoded.append('redirect_uri', 'https://phoenix-pages.izmichael.com/auth');
        // urlencoded.append('redirect_uri', 'http://localhost:5000/auth');

        var auth = await fetch('https://discord.com/api/oauth2/token', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            },
            body: urlencoded
        }).then(res => {
            return res.json()
        });

        window.localStorage.setItem('refresh_token', auth.refresh_token);
        window.localStorage.setItem('access_token', auth.access_token);

        // Get user from tokens

        var user = await fetch('https://discord.com/api/users/@me', {
            method: 'GET',
            headers: {
                'Authorization': 'Bearer ' + auth.access_token
            }
        }).then(res => {
            return res.json()
        });

        window.localStorage.setItem('user', JSON.stringify(user));

        // Get Pages DB User

        let players = await fetch('https://api.phoenix-pages.izmichael.com/players', {
            headers: {
                'Authorization': 'iIZti8qsxy3cPs0MMrIz0aYtqIOrhjPi8'
            }
        }).then(res => {return res.json()});

        let player = players.filter(a => a.PlayerDiscord == user.id)[0];
        window.localStorage.setItem('player', JSON.stringify(player));

        // Redirect to Homepage

        window.location = params.redirect || '/';
    });
</script>